"use client"

import Link from "next/link"
import { useState, useEffect } from "react"
import { Menu, X, User } from "lucide-react"
import Image from "next/image"
import { useSession } from "next-auth/react"


export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const { data: session } = useSession()



  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])


  return (
    <header
      role="banner" className={`fixed w-full z-40 transition-all duration-300 bg-white shadow-md ${isMobileMenuOpen ? "py-2" : "py-4"}`}
    >
      <div className="container px-4 mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex-grow text-center md:text-left md:flex-grow-0">
            <Link href="/" className="flex items-center justify-center md:justify-start">
              <span className="text-2xl font-bold text-primary-gold">
                Alquileres Temporarios
              </span>
            </Link>
          </div>
          <nav role="navigation" className="hidden md:flex items-center space-x-8">
            {[
              { name: "Inicio", href: "/" },
              { name: "Apartamentos", href: "/apartments" },
              { name: "Acerca de", href: "/about" },
              { name: "Contacto", href: "/contact" },
              ...(session?.user?.role === "ADMIN" ? [{ name: "Admin", href: "/admin" }] : []),
            ].map((item) => (
              <Link
                key={item.name}
                href={item.href}
                className="font-medium transition-colors text-gray-700 hover:text-primary-gold"
              >
                {item.name}
              </Link>
            ))}
            {session ? (
              <Link href={`/profile/${session.user.id}`} className="flex items-center">
                <Image
                  src={session.user?.image || "/placeholder.svg"}
                  priority
                  alt="User"
                  width={40}
                  height={40}
                  className="rounded-full transform transition duration-300 ease-in-out hover:scale-110"

                />
              </Link>
            ) : (
              <Link href="/auth" className="flex items-center">
                <div className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors">
                  <User className="w-6 h-6 text-gray-700" />
                </div>
              </Link>
            )}
          </nav>
          <button className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? (
              <X className="text-gray-800" />
            ) : (
              <Menu className="text-gray-800" />
            )}
          </button>
        </div>
        {isMobileMenuOpen && (
          <nav className="md:hidden pt-4 pb-2 z-50">
            <div className="flex flex-col space-y-3 bg-white rounded-lg p-4">
              {[
                { name: "Inicio", href: "/" },
                { name: "Apartamentos", href: "/apartments" },
                { name: "Acerca de", href: "/about" },
                { name: "Contacto", href: "/contact" },
                ...(session?.user?.role === "ADMIN"
                  ? [{ name: "Admin", href: "/admin" }]
                  : []),
              ].map((item) => (
                <Link
                  key={item.name}
                  href={item.href}
                  className="font-medium text-gray-700 hover:text-primary-gold"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              {session ? (
                <Link
                  href={`/profile/${session.user.id}`}
                  className="font-medium text-gray-700 hover:text-primary-gold"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {session.user?.name || session.user?.email}
                </Link>
              ) : (
                <Link
                  href="/auth"
                  className="font-medium text-gray-700 hover:text-primary-gold"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {"Iniciar Sesion"}
                </Link>
              )}
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}